import { render, staticRenderFns } from "./Electronic.vue?vue&type=template&id=37237af3&scoped=true&"
import script from "./Electronic.vue?vue&type=script&lang=js&"
export * from "./Electronic.vue?vue&type=script&lang=js&"
import style0 from "./Electronic.vue?vue&type=style&index=0&id=37237af3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37237af3",
  null
  
)

export default component.exports